export default {
  na: 'notAssigned',
  BinLocation: 'binLocation',
  BinSubLocation: 'binSublocation',
  CustomerPartNumber: 'customerPartNumber',
  EmployeeName: 'employeeName',
  AccountNumber: 'accountNumber',
}
